<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Add Funds
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4" label="Employer" label-align="right" :state="stateForField('name')" :invalid-feedback="errorForField('name')">
              <b-form-input v-if="paymentDistribution.employer" :value="paymentDistribution.employer.name" plaintext></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Source Account" label-align="right" :state="stateForField('organizationAccountId')" :invalid-feedback="errorForField('organizationAccountId')">
              <b-form-input v-if="accounts.length == 1" v-model="transfer.account.name" plaintext></b-form-input>
              <b-dropdown v-if="accounts && accounts.length > 1" menu-class="dropdown-container" :text="transfer.account.name"
                          :variant="hasError('organizationAccountId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="account in accounts" :key="account.organizationAccountId"
                                 @click.prevent="setAccount(account)">{{ account.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4" label="Amount" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group prepend="$"><b-form-input v-model="transfer.amount"></b-form-input></b-input-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'

  export default {
    name: 'FundDistributionModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      paymentDistribution: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        transfer: {
          organizationAccountId: 0,
          account: {
            name: 'Select Account'
          },
          amount: 0.00
        },
        accounts: [],
        isSaving: false,
        searchTerm: '',
        matchedCodes: []
      }
    },

    watch: {
      paymentDistribution (newValue, oldValue) {
        this.clearAllErrors()
        if (newValue !== oldValue && newValue) {
          if (this.paymentDistribution.maxFundingAmount === 0) {
            this.transfer.amount = this.paymentDistribution.price
          } else {
            this.transfer.amount = this.paymentDistribution.maxFundingAmount
          }
          this.accounts = this.paymentDistribution.employer.accounts
          if (this.paymentDistribution.employer.accounts.length === 1) {
            this.transfer.account = this.paymentDistribution.employer.accounts[0]
            this.transfer.organizationAccountId = this.transfer.account.organizationAccountId
          }
        }
      }
    },

    computed: {
    },

    methods: {
      validate () {
        this.clearAllErrors()

        return !this.hasErrors()
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        this.isSaving = true
        api.post('/Dashboard/PaymentDistribution/' + this.paymentDistribution.organizationBundlePaymentDistributionId + '/Fund', this.transfer).then(response => {
          this.$emit('fundingAdded', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to fund payment distribution: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.clearAllErrors()
        this.$emit('update:visible', false)
      },

      setAccount (account) {
        this.transfer.account = account
        this.transfer.organizationAccountId = account.organizationAccountId
      }
    }
  }
</script>

<style scoped>

</style>
